import { TrafficAreaFormValues } from '../../types'
import { useTexts } from './hooks/useTexts'

import { form } from '../../formState'
import { DrawArea } from './components/DrawArea'
import { FirstTimeWindow } from './components/FirstTimeWindow'
import { Level } from './components/Level'
import { Name } from './components/Name'
import { SecondTimeWindow } from './components/SecondTimeWindow'

type Props = {
  initialValues: TrafficAreaFormValues
}

export function FormContent(props: Props) {
  const {
    initialValues: { firstTimeWindowValue, secondTimeWindowValue },
  } = props

  const texts = useTexts()

  return (
    <>
      <Name />

      <DrawArea />

      <form.Divider />

      <Level />

      {!!firstTimeWindowValue && <form.SectionTitle>{texts.timeWindows}</form.SectionTitle>}

      <FirstTimeWindow hidden={!firstTimeWindowValue} />
      <SecondTimeWindow hidden={!secondTimeWindowValue} />
    </>
  )
}
